import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  USER_UPDATE_CONFIG,
  USER_UPDATE_REQUEST,
  USER_PASSWORD_CHANGE_REQUEST,
  USER_NAME_CHANGE_REQUEST,
} from '../constants/ActionTypes';
import {
  getIsSelectedUserFetching,
  getIsSelectedUserConfig,
} from '../reducers';
import { users, setAuthorizationHeader } from '../api';
import storage from '../storage';
import { timeoutPromise } from '../helpers/promises';

export const fetchUser = () => async (dispatch, getState) => {
  try {
    if (getIsSelectedUserFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    dispatch({
      type: FETCH_USER_REQUEST,
    });

    const data = await users.getUser();

    dispatch({
      type: FETCH_USER_SUCCESS,
      data,
    });

    await timeoutPromise(200);

    return Promise.resolve();
  } catch (error) {
    let message = 'Undfined Error';

    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      message = error.response.data.message;
    } else if (error.message) {
      message = error.message;
    }

    dispatch({
      type: FETCH_USER_FAILURE,
      message,
    });

    return Promise.reject(message);
  }
};

export const updateUserConfig = (data) => (dispatch) => {
  dispatch({
    type: USER_UPDATE_CONFIG,
    data,
  });
};

export const saveUserConfig = () => (dispatch, getState) => {
  dispatch({
    type: USER_UPDATE_REQUEST,
  });

  setAuthorizationHeader(storage.getItem('token'));

  const config = getIsSelectedUserConfig(getState());

  return users.setConfigurations(config);
};

export const changePassword = (data) => (dispatch) => {
  dispatch({
    type: USER_PASSWORD_CHANGE_REQUEST,
  });

  setAuthorizationHeader(storage.getItem('token'));

  return users.changePassword(data);
};

export const changeName = (data) => (dispatch) => {
  dispatch({
    type: USER_NAME_CHANGE_REQUEST,
  });

  setAuthorizationHeader(storage.getItem('token'));

  return users.changeName(data);
};

export const setAddress =
  (data = {}) =>
  () => {
    setAuthorizationHeader(storage.getItem('token'));

    return users.setAddress(data);
  };

export const setGst =
  (data = {}) =>
  () => {
    setAuthorizationHeader(storage.getItem('token'));

    return users.setGst(data);
  };

export const setEmail =
  (data = {}) =>
  () => {
    setAuthorizationHeader(storage.getItem('token'));

    return users.setEmail(data);
  };

export const setMobile =
  (data = {}) =>
  () => {
    setAuthorizationHeader(storage.getItem('token'));

    return users.setMobile(data);
  };
